// Placeholder API key for TMDB (replace with your own key)
// Exported as default string
const API_KEY_V4 = "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIzZTU2ZjFkNDQwOGY3MjkxNDgyNTFhMzkyOWI1NTcxYiIsIm5iZiI6MTc3ODIzNjAyNS4xNTI5OTk5LCJzdWIiOiI2OWZkYmE3OTBlMDNjMDFiMjZhYTk3YmQiLCJzY29wZXMiOlsiYXBpX3JlYWQiXSwidmVyc2lvbiI6MX0.6wT8J0ZMEbgtqsWs4q0TlMhHHrgIB9v0usUab5gZ50Y";
export default API_KEY_V4;
